import {ActionCreator, createReducer, on} from '@ngrx/store';
import * as catalogAction from '../../common/catalog/catalog.actions';
import * as cartActions from '../../common/shopping-cart/cart.actions';
import * as errorAction from '../../common/error-handling/error-handling.actions';
import * as addressActions from '../../tax-and-shipping/address.actions';
import * as addOnAction from '../add-on.actions';
import {
  routerCancelAction,
  routerErrorAction,
  routerNavigatedAction,
} from '@ngrx/router-store';
import {LOADING_INCREMENT_TYPES} from './loading.constants';

export const loadingKey = 'loadingKey';

export interface LoadingState {
  loading: number;
}

export const initialState: LoadingState = {
  loading: 0,
};

export const reducer = createReducer(
  initialState,
  on(...(LOADING_INCREMENT_TYPES as readonly ActionCreator[]), state => ({
    ...state,
    loading: state.loading + 1,
  })),
  on(
    routerNavigatedAction,
    addOnAction.initializationComplete,
    addOnAction.loadAddonSuccess,
    addOnAction.loadAddonFailed,
    addOnAction.loadAddOnsFailure,
    addOnAction.loadAddOnsSuccess,
    cartActions.cartActionFailure,
    cartActions.cartSubmitFailure,
    cartActions.loadCartSuccess,
    cartActions.addItemToCartSuccess,
    cartActions.addItemToCartSuccessThenContinue,
    cartActions.addItemToCartSuccessAndContinueToShipping,
    cartActions.removeItemFromCartSuccessThenShipping,
    cartActions.removeItemFromCartSuccess,
    cartActions.completeOrderSuccess,
    catalogAction.loadQualifyingCatalogIdsSuccess,
    catalogAction.loadCatalogsFailure,
    addressActions.createAddressSuccess,
    addressActions.createAddressFailure,
    addressActions.submitAddressSuccess,
    addressActions.submitAddressFailure,
    state => ({
      ...state,
      loading: Math.max(0, state.loading - 1),
    }),
  ),
  on(addOnAction.hideLoadingIndicator, state => ({
    ...state,
    loading: 0,
  })),
  on(
    routerErrorAction,
    routerCancelAction,
    errorAction.unrecoverableError,
    errorAction.uncaughtError,
    state => ({
      ...state,
      loading: 0,
    }),
  ),
);

export const getIsLoading = (state: LoadingState): boolean => state.loading > 0;
